import styled, { css } from 'styled-components/macro';
import ResponsiveContainer from '../../layout/ResponsiveContainer';
import mq from '../../../utils/mediaQueriesBp';
interface ITag {
  isSelected: boolean;
}
const Wrapper = styled(ResponsiveContainer)`
  flex-direction: column;
  margin-top: 47px;
`;

const Categories = styled.div`
  position: relative;
  display: flex;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    border: 1px solid ${p => p.theme.colors.nav_purple};
    border-radius: 4px;
    z-index: -1;
  }

  button {
    padding: 7px 19px 9px;
    border: 1px solid transparent;
    color: ${p => p.theme.colors.nav_purple};
    background-color: transparent;
    cursor: pointer;
    font-size: 14px;
    flex: 1;

    ${mq('desktop')} {
      padding: 7px 29px 9px;
      flex: unset;
    }

    &:first-child {
      border-radius: 4px 0 0 4px;
      flex: unset;
      width: 25%;

      ${mq('desktop')} {
        width: max-content;
      }
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
    }

    &:hover {
      border: 1px solid ${p => p.theme.colors.accent_orange};
      color: ${p => p.theme.colors.accent_orange};
    }

    &.active {
      background-color: ${p => p.theme.colors.accent_orange};
      border-color: ${p => p.theme.colors.accent_orange};
      color: ${p => p.theme.colors.white};
    }
  }
`;
const HeadingRow = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: 100%;
  row-gap: 20px;
  column-gap: 16px;
  align-items: center;
  width: 100%;
  margin-bottom: 32px;

  ${mq('desktop')} {
    grid-template-columns: minmax(min-content, max-content) auto;
  }

  &.with-categories {
    ${mq('desktop')} {
      justify-items: end;
      align-items: start;

      ${Categories} {
        grid-column: 2;
      }

      h1 {
        grid-row: 1/3;
      }
    }

    ${mq('middle')} {
      grid-template-columns: 1fr auto max-content;
      justify-items: unset;

      ${Categories} {
        grid-column: unset;
      }

      h1 {
        grid-row: unset;
      }
    }
  }

  h1 {
    line-height: 1.2;
    margin: 0;
    text-align: left;
  }

  .tagsearch {
    width: 100%;
    height: 34px;

    ${mq('desktop')} {
      width: 315px;
    }

    &__control {
      flex-direction: row-reverse;
      height: 34px;
      min-height: unset;
      background-color: ${p => p.theme.colors.white};
      border-color: ${p => p.theme.colors.border_2};
      outline: none;
      box-shadow: unset;

      &:hover {
        border-color: ${p => p.theme.colors.nav_purple};
      }

      &--is-focused {
        border: none;
        box-shadow: 0 0 0 2px ${p => p.theme.colors.nav_purple};
      }
    }

    &__indicator {
      padding: 6px 10px 6px 6px;
    }

    &__value-container {
      padding-inline: 0;
    }

    &__placeholder {
      font-size: 15px;
      color: hsl(0, 0%, 60%);
    }

    &__menu {
      z-index: 10;
    }

    &__menu-list {
      padding-top: 0;
      padding-bottom: 0;
      border-radius: 5px;
    }

    &__menu-notice {
      &--no-options {
        background-color: ${p => p.theme.colors.accent_orange};
        color: ${p => p.theme.colors.white};
        padding-top: 16px;
        padding-bottom: 16px;
        padding-inline: 16px;
        text-align: left;
        font-size: 15px;
      }
    }

    &__option {
      &:first-child {
        margin-top: 16px;
      }
      &:last-child {
        margin-bottom: 16px;
      }

      &--is-focused {
        background-color: ${p => p.theme.colors.backgroundLightBlue};
        cursor: pointer;
      }
    }
  }
`;

const ShowLessButton = styled.button`
  padding: 8px 0;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  color: ${p => p.theme.colors.primary};
  cursor: pointer;
  background-color: transparent;
  border: none;
`;

const HashtagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 238px;
  overflow: hidden;
  margin-bottom: 32px;

  ${mq('tablet')} {
    max-height: 156px;
  }

  ${mq('laptop')} {
    max-height: 115px;
  }

  ${mq('desktop')} {
    max-height: 74px;
  }

  &.opened {
    max-height: unset;

    .show-more {
      display: none;
    }

    ${ShowLessButton} {
      display: unset;
    }
  }

  .show-more {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 15px;
    line-height: 1;
    cursor: pointer;
    user-select: none;
    border: 1px solid ${p => p.theme.colors.nav_purple};
    color: ${p => p.theme.colors.nav_purple};

    &:hover {
      border-color: ${p => p.theme.colors.accent_orange};
      color: ${p => p.theme.colors.accent_orange};
    }
  }

  ${ShowLessButton} {
    display: none;
  }
`;

const Hashtag = styled.p<ITag>`
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  background-color: ${p => p.theme.colors.white};

  ${p =>
    p.isSelected
      ? css`
          display: flex;
          align-items: center;
          column-gap: 11px;
          background-color: ${p.theme.colors.accent_orange};
          border: 1px solid ${p.theme.colors.accent_orange};
          color: ${p.theme.colors.white};
          svg {
            height: 14px;
            width: 14px;

            path {
              fill: ${p.theme.colors.accent_orange};
            }
            circle {
              fill: ${p.theme.colors.white};
            }
          }
        `
      : css`
          border: 1px solid ${p.theme.colors.nav_purple};
          color: ${p.theme.colors.nav_purple};

          &:hover {
            border-color: ${p.theme.colors.accent_orange};
            color: ${p.theme.colors.accent_orange};
          }
        `}
`;

const ClearButton = styled.button`
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  background-color: transparent;
  border: 1px solid ${p => p.theme.colors.accent_orange};
  color: ${p => p.theme.colors.accent_orange};

  &:hover {
    background-color: ${p => p.theme.colors.accent_orange};
    color: ${p => p.theme.colors.white};
  }

  &:active {
    background-color: ${p => p.theme.colors.accent_orange_active};
  }
`;

export {
  Wrapper,
  HeadingRow,
  Categories,
  HashtagsContainer,
  Hashtag,
  ClearButton,
  ShowLessButton,
};
